(function($) {
  'use strict';
  $('.course-search-results__dropdown select').on('change', function() {
    const $selected = $(this).find(':selected');
    const partial = $selected.data('partial');
    const [key, val] = partial.split('=');
    const [paramVal, hashVal] = val.split('#');

    var url = new URL(window.location.href);

    url.searchParams.set(key, paramVal);
    url.hash = hashVal || '';
    window.location.href = url;
  });
})(jQuery);
